<template>
  <BaseBadge :color="color" size="sm">{{ label }}</BaseBadge>
</template>

<script>
import BaseBadge from '../base/BaseBadge.vue';

export default {
  components: {
    BaseBadge,
  },
  props: {
    areaStatus: String,
  },
  computed: {
    color() {
      return {
        mismatch_address: 'yellow',
        route: 'blue',
      }[this.areaStatus];
    },
    label() {
      return {
        mismatch_address: 'Tidak Sesuai',
        route: 'Kebijakan',
      }[this.areaStatus];
    },
  },
};
</script>
